import React from 'react'
import { Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Video as VideoType } from '../../types/video'

interface Props {
  video: VideoType
}

const Player: React.FC<Props> = ({ video }) => {
  const { classes } = useStyles()

  return (
    <Box className={classes.box}>
      <video
        className={classes.video}
        playsInline
        muted={video.autoPlay}
        {...video}
      >
        {video.videoSources.map((source) => (
          <source key={source.contentful_id} src={source.file.url} />
        ))}
      </video>
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  box: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },

  video: {
    height: '100%',
    maxWidth: '100%',
  },
}))

export default Player
